export const withdrawal = state => state.withdrawal
export const withdrawals = state => state.withdrawals
export const countStatesWithdrawal = state => state.countStatesWithdrawal
